module.exports = __webpack_public_path__ + "img/Coupe_Back_Side_Right.d1abe153.svg";